import axios from 'axios'
import QS from 'qs'
import { Notification } from 'element-ui';
const origin = location.origin;
const BASE_API = String.prototype.replace.call(process.env.BASE_API, /#/, origin);
import Cookies from 'js-cookie'

/*
  @ 创建自定义axios实例
*/
const instanceAx = axios.create({
  baseURL: process.env.BASE_API,
  headers: {
    //'Content-Type': 'application/json'
    // 'token': Cookies.get('token')
  },
  timeout: 10000
})

/*
  @ request 请求拦截器=>请求发出前处理
*/
instanceAx.interceptors.request.use(
  config => {
    const timestamp = new Date().getTime();
    var reg = /\/test\/[\w/]+/;
    // 动态设置请求头
    config.headers.token = Cookies.get('token');
    // config.headers.token = '1234567';
    var token = Cookies.get('token');
    sessionStorage.setItem('token', token);
    // if (config.method === 'post' || config.method === 'put') {
    //   // post请求时，序列化入参
    //   config.data = QS.stringify(config.data)
    // }
    const inBody = config.method.toLowerCase() === 'post' || config.method.toLowerCase() === 'put';
    if (!reg.test(config.url) && inBody) {
      if (config.data instanceof FormData) {
        var data = new FormData();
        config.data.append('token', token);
        config.data.append('timestamp', timestamp);
        return config;
      }
      // console.log(config.data);
      config.data = {
        // loginId: getLoginId(),
        ...config.data,
        token: token,
        // signature: toMd5(getLoginId() + timestamp + key),
        // timestamp: timestamp
      };
    }
    if ((config.method.toLowerCase() === 'delete' || config.method.toLowerCase() === 'get') && config.data) {
      // config.data.token = token;
      // config.data.timestamp = timestamp;
      // qs.stringify(config.data, { arrayFormat: 'indices' });
      config.url = config.url + '?' + QS.stringify(config.data, { arrayFormat: 'repeat' });
    }
    return config
  }, error => {
    // 接口返回失败
    Promise.reject(error.response)
  }
)

/*
  @ request 响应拦截器=>处理响应数据
*/
instanceAx.interceptors.response.use(
  response => {
    var data = response.data
    return Promise.resolve(data)
  },
  error => {
    // //请求失败，这个地方可以根据error.response.status统一处理一些界面逻辑，比如status为401未登录,可以进行重定向
    // router.replace({
    //     path: '/login',
    //     query: { redirect: router.currentRoute.fullPath }
    //    });
    Notification({
      title: '系统提示',
      message: error.message,
      type: 'error',
      duration: 3000
    });
    return Promise.reject(error);
  }
)

export default instanceAx



// WEBPACK FOOTER //
// ./src/untils/request/request.js